import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=384570d5&ref=container"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=384570d5&prod&lang=scss"
import style1 from "./Item.vue?vue&type=style&index=1&id=384570d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports